import axios from 'axios';
// const BASE_URL = 'http://localhost:3500/'
//const BASE_URL = 'https://escalation-staging-ir.staging.support.meltwater.io/'
//const BASE_URL = 'https://escalationtool.staging.support.meltwater.io/'
//const BASE_URL = 'https://esctoolv2.staging.support.meltwater.io/'
const BASE_URL = 'https://escv2prod.support.meltwater.io/' // new url

export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({ 
    baseURL: BASE_URL,
    headers: {'Content-Type': 'application/json'},
    withCredentials: true
});
